(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firmware-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const allWrappers = document.querySelectorAll(".faq-title-wrapper");

    allWrappers.forEach(wrapper => {
      // Skip toggle if it's an always open block
      if (wrapper.classList.contains("faq-always-open")) return;

      const title = wrapper.querySelector("h3");
      const collapse = wrapper.querySelector(".faq-collapse");

      if (title && collapse) {
        // ensure collapsed by default
        collapse.classList.remove("show");
        title.classList.remove("open");

        title.addEventListener("click", () => {
          collapse.classList.toggle("show");
          title.classList.toggle("open");
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-text-animated"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

setTimeout(() => {

let mm = gsap.matchMedia();

let imageRight = gsap.utils.toArray('.ImageOnRight');
let videosItem = gsap.utils.toArray('.videos');

imageRight.forEach((imageRightWrapper) => {
let imageRightText = imageRightWrapper.querySelector('.ITAContainerText');
let imageRightImage = imageRightWrapper.querySelector('.ITAContainerImage');
mm.add("(min-width: 770px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: imageRightWrapper,
start: "top center",
end: "",
scrub: false
}
});
ImageTextAnimatedRight.fromTo(imageRightText, {x: -180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightImage, {x: 180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
mm.add("(max-width: 769px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: ".ImageOnRight",
start: "top+=120 60%",
end: "bottom 80%"
}
});
ImageTextAnimatedRight.fromTo(imageRightImage, {y: 400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightText, {y: -400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
});


let imageLeft = gsap.utils.toArray('.ImageOnLeft');
imageLeft.forEach((imageLeftWrapper) => {
let imageLeftText = imageLeftWrapper.querySelector('.ITAContainerText');
let imageLeftImage = imageLeftWrapper.querySelector('.ITAContainerImage');

mm.add("(min-width: 769px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: "",
scrub: false
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {x: 180, opacity: 0}, {x: 0, opacity: 1});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {x: -180, opacity: 0}, {x: 0,opacity: 1});
});
mm.add("(max-width: 768px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: ""
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {y: 300, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {y: -300, opacity: 0}, {
y: 0,
opacity: 1
});
});
});

}, 1000);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-with-icon"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
const videoItems = document.querySelectorAll('.VideoSliderItem');
const closeButtons = document.querySelectorAll('.close-btn');
const soundIcons = document.querySelectorAll('.modal-sound-icon');

videoItems.forEach(function (item) {
item.addEventListener('click', function () {
const id = item.getAttribute('data-id');
const modal = document.querySelector(`.youtube-modal[data-id="${id}"], .instagram-modal[data-id="${id}"]`);
if (modal) {
modal.style.display = 'flex';
document.body.classList.add('no-scroll');
const video = modal.querySelector('video');
if (video) {
video.play();
video.muted = true;
}
const soundIcon = modal.querySelector('.modal-sound-icon');
if (soundIcon) {
soundIcon.src = 'https://cdn.shopify.com/s/files/1/0597/7853/1477/files/Sound_d4349df7-81ff-45f3-bafe-02e80bb01504.svg?v=1683793914'; // Ses ikonunu kapalı ikonla güncelle
}
}
});
});

closeButtons.forEach(function (button) {
button.addEventListener('click', function () {
const modal = button.closest('.youtube-modal, .instagram-modal');
if (modal) {
if (modal.classList.contains('youtube-modal')) {
const iframe = modal.querySelector('iframe');
const src = iframe.src;
iframe.src = '';
iframe.src = src;
} else if (modal.classList.contains('instagram-modal')) {
const video = modal.querySelector('.instagram-modal video');
if (video) {
video.pause();
video.currentTime = 0;
video.muted = true;
}
}
modal.style.display = 'none';
document.body.classList.remove('no-scroll');
}
});
});

soundIcons.forEach(function (icon) {
icon.addEventListener('click', function () {
const video = icon.previousElementSibling;

if (video.muted) {
video.muted = false;
icon.src = 'https://cdn.shopify.com/s/files/1/0597/7853/1477/files/Sound.svg?v=1683793909';
} else {
video.muted = true;
icon.src = 'https://cdn.shopify.com/s/files/1/0597/7853/1477/files/Sound_d4349df7-81ff-45f3-bafe-02e80bb01504.svg?v=1683793914';
}
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-text-list-button"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

    const elements = document.querySelectorAll('.fade-in');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {

            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            } else {
                // Remove if you want animation to happen only once
                entry.target.classList.remove('visible');
            }

        });
    }, {
        threshold: 0.2
    });

    elements.forEach(el => observer.observe(el));

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja-image-and-text-animated"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {

let mm = gsap.matchMedia();

let imageRight = gsap.utils.toArray('.ImageOnRight');
imageRight.forEach((imageRightWrapper) => {
let imageRightText = imageRightWrapper.querySelector(' .ITAContainerText');
let imageRightImage = imageRightWrapper.querySelector(' .ITAContainerImage');
mm.add("(min-width: 770px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: imageRightWrapper,
start: "top 50%",
end: "bottom 80%",
scrub: true
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});
ImageTextAnimatedRight.fromTo(imageRightText, {x: -80, opacity: 0}, {
x: 0,
opacity: 1
});
ImageTextAnimatedRight.fromTo(imageRightImage, {x: 80, opacity: 0}, {
x: 0,
opacity: 1
});
});
mm.add("(max-width: 769px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: ".ImageOnRight",
start: "top+=120 60%",
end: "bottom 80%"
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});
ImageTextAnimatedRight.fromTo(imageRightImage, {y: 400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.fromTo(imageRightText, {y: -400, opacity: 0}, {
y: 0,
opacity: 1
});
});
});


let imageLeft = gsap.utils.toArray('.ImageOnLeft');
imageLeft.forEach((imageLeftWrapper) => {
let imageLeftText = imageLeftWrapper.querySelector('.ITAContainerText');
let imageLeftImage = imageLeftWrapper.querySelector('.ITAContainerImage');

mm.add("(min-width: 769px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top 30%",
end: "bottom 60%",
scrub: true
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {x: 80, opacity: 0}, {x: 0, opacity: 1, duration: 2, delay: -2});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {x: -80, opacity: 0, duration: 2}, {
x: 0,
opacity: 1,
delay: -2
});
});
mm.add("(max-width: 768px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top 60%",
end: "bottom 90%"
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {y: 300, opacity: 0}, {
y: 0,
opacity: 1,
delay: -1
});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {y: -300, opacity: 0}, {
y: 0,
opacity: 1,
delay: -2
});
});
});

}, 1000);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlm-premium-mem-plan"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.CountryWrapper').forEach(wrapper => {
    const select = wrapper.querySelector('select');
    const planRight = wrapper.closest('.FlexRow')?.querySelector('.plan-right');

    if (!select || !planRight) return;

    const priceEl = planRight.querySelector('.price');
    const monthlyEl = planRight.querySelector('.monthly');
    const taxInfoEl = planRight.querySelector('.tax-info');

    const validPlans = {};
    Array.from(select.options).forEach(option => {
      validPlans[option.value] = {
        plan: option.dataset.planPrice,
        monthly: option.dataset.monthlyPrice
      };
    });

    const updatePrices = () => {
      const selectedKey = select.value;
      if (validPlans[selectedKey]) {
        priceEl.textContent = validPlans[selectedKey].plan || '';
        monthlyEl.textContent = validPlans[selectedKey].monthly || '';
      } else {
        const defaultKey = select.options[0].value;
        select.selectedIndex = 0;
        priceEl.textContent = validPlans[defaultKey].plan || '';
        monthlyEl.textContent = validPlans[defaultKey].monthly || '';
      }

      
      if (taxInfoEl) {
        if (selectedKey === 'restofworld') {
          taxInfoEl.style.display = 'none';
        } else {
          taxInfoEl.style.display = 'inline';
        }
      }
    };

    select.addEventListener('change', updatePrices);
    updatePrices(); 
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-page-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.RangefinderCheckbox');

    const desktopInput =
        document.getElementById('RangefinderVariant');

    const mobileInput =
        document.getElementById('RangefinderVariantMobile');

    if (!checkboxes.length) return;

    function updateRangefinder() {
        const selectedIds = [];

        checkboxes.forEach((checkbox) => {
            const card = checkbox.closest('.RangefinderCard');

            if (card) {
                card.classList.toggle(
                    'active',
                    checkbox.checked
                );
            }

            if (checkbox.checked) {
                selectedIds.push(
                    checkbox.dataset.id
                );
            }
        });

        const value = selectedIds.join(',');

        if (desktopInput) {
            desktopInput.value = value;
        }

        if (mobileInput) {
            mobileInput.value = value;
        }
    }

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener(
            'change',
            updateRangefinder
        );
    });

    updateRangefinder();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-page-v3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.RangefinderCheckbox');

    const desktopInput =
        document.getElementById('RangefinderVariant');

    const mobileInput =
        document.getElementById('RangefinderVariantMobile');

    if (!checkboxes.length) return;

    function updateRangefinder() {
        const selectedIds = [];

        checkboxes.forEach((checkbox) => {
            const card = checkbox.closest('.RangefinderCard');

            if (card) {
                card.classList.toggle(
                    'active',
                    checkbox.checked
                );
            }

            if (checkbox.checked) {
                selectedIds.push(
                    checkbox.dataset.id
                );
            }
        });

        const value = selectedIds.join(',');

        if (desktopInput) {
            desktopInput.value = value;
        }

        if (mobileInput) {
            mobileInput.value = value;
        }
    }

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener(
            'change',
            updateRangefinder
        );
    });

    updateRangefinder();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rapsodo-mission"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRapsodoMission(section) {
      if (!section || section.dataset.missionInitialized === 'true') return;

      section.dataset.missionInitialized = 'true';

      var outlineElements = Array.prototype.slice.call(
        section.querySelectorAll('.RapsodoMission__outline')
      );

      if (!outlineElements.length) return;

      // Keep all outline text hidden until its scroll threshold is reached.
      outlineElements.forEach(function (element) {
        element.classList.remove('is-visible');
      });

      var ticking = false;

      function updateOutlineVisibility() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var sectionTop = section.getBoundingClientRect().top + scrollY;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        // Reveal the first outline as the section enters the viewport,
        // then reveal the remaining outlines at staggered scroll positions.
        var firstRevealPoint = sectionTop - viewportHeight * 0.75;
        var revealSpacing = viewportHeight * 0.18;
        var revealCount = 0;

        outlineElements.forEach(function (element, index) {
          var revealPoint = firstRevealPoint + (index * revealSpacing);
          // Reveal each outline only once. Keep it visible even if the user
          // scrolls back up; it resets naturally when the page is refreshed.
          if (scrollY >= revealPoint && !element.classList.contains('is-visible')) {
            element.classList.add('is-visible');
          }
        });

        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(updateOutlineVisibility);
          ticking = true;
        }
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateOutlineVisibility();
    }

    function initAllRapsodoMissions() {
      document.querySelectorAll('.RapsodoMission').forEach(initRapsodoMission);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllRapsodoMissions);
    } else {
      initAllRapsodoMissions();
    }

    // Re-initialize sections when Shopify reloads them in the Theme Editor.
    document.addEventListener('shopify:section:load', function (event) {
      var shopifySection = event.target;
      var mission = shopifySection.querySelector
        ? shopifySection.querySelector('.RapsodoMission')
        : null;

      if (mission) {
        mission.dataset.missionInitialized = 'false';
        initRapsodoMission(mission);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["who-we-are"] && !Shopify.designMode) return;
  try {
    
var acc = document.getElementsByClassName("accordionBox");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.querySelector('.R-panel');
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
